import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import { z } from 'zod';
import { ARTIFACT_PATH_NAME } from './artifact.constants';
import { BaseArtifactDtoSchema } from './artifact-base.schema';
import {
  ArtifactFilterQuerySchema,
  CreateArtifactBodySchema,
  UpdateArtifactBodySchema,
} from './artifact.schema';
import {
  BrowserRecordingUrlResponseSchema,
  BrowserScreenshotUrlResponseSchema,
} from './browser-recording.schema';

const ArtifactIdParamsSchema = z.object({
  artifactId: z.string(),
});

export const ArtifactContract = terraContract
  .prefix(`/${ARTIFACT_PATH_NAME}`)
  .router({
    createArtifact: terraContract
      .meta({
        permissions: [PERMISSIONS.EXECUTE_TESTS.name],
      })
      .route({
        method: 'POST',
        path: '/',
        summary: 'Create an artifact',
        inputStructure: 'detailed',
        successStatus: 201,
      })
      .input(z.object({ body: CreateArtifactBodySchema }))
      .output(BaseArtifactDtoSchema),
    getArtifactById: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_TESTS.name],
      })
      .route({
        method: 'GET',
        path: '/{artifactId}',
        summary: 'Get artifact by ID',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: ArtifactIdParamsSchema }))
      .output(BaseArtifactDtoSchema),
    getArtifactRecordingUrl: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_TESTS.name],
      })
      .route({
        method: 'GET',
        path: '/{artifactId}/recording-url',
        summary: 'Get a signed URL for the browser recording of an artifact',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: ArtifactIdParamsSchema }))
      .output(BrowserRecordingUrlResponseSchema),
    getArtifactScreenshotUrl: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_TESTS.name],
      })
      .route({
        method: 'GET',
        path: '/{artifactId}/screenshot-url',
        summary: 'Get a signed URL for the browser screenshot of an artifact',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: ArtifactIdParamsSchema }))
      .output(BrowserScreenshotUrlResponseSchema),
    getArtifactsByFilter: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_TESTS.name],
      })
      .route({
        method: 'GET',
        path: '/',
        summary: 'Get artifacts by filter',
        inputStructure: 'detailed',
      })
      .input(z.object({ query: ArtifactFilterQuerySchema }))
      .output(z.array(BaseArtifactDtoSchema)),
    updateArtifact: terraContract
      .meta({
        permissions: [PERMISSIONS.EXECUTE_TESTS.name],
      })
      .route({
        method: 'PATCH',
        path: '/{artifactId}',
        summary: 'Update an artifact',
        inputStructure: 'detailed',
      })
      .input(
        z.object({
          params: ArtifactIdParamsSchema,
          body: UpdateArtifactBodySchema,
        }),
      )
      .output(BaseArtifactDtoSchema),
    deleteArtifact: terraContract
      .meta({
        permissions: [PERMISSIONS.EXECUTE_TESTS.name],
      })
      .route({
        method: 'DELETE',
        path: '/{artifactId}',
        summary: 'Delete an artifact',
        inputStructure: 'detailed',
      })
      .input(z.object({ params: ArtifactIdParamsSchema, body: z.object({}) }))
      .output(z.object({ success: z.boolean() })),
  });
